import styled from 'styled-components'

export const StyledDescription = styled.div`
    .show-toggle {
        color: ${(props) => props.theme.brand02};
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        margin-left: 5px;
        text-decoration: underline;
        white-space: nowrap;
    }
`
